import {
  Container,
  Typography,
  Box,
  Divider,
  Paper,
} from "@mui/material";
import Page from "../component/Page";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import ReusableTabs from "../component/ReusableTabs";

const wf = [
  {
    label: "NIFC Wildfire Danger Current Month Outlook",
    src: "https://www.predictiveservices.nifc.gov/outlooks/month1_outlook.png",
  },
  {
    label: "NIFC Wildfire Danger Next Month Outlook",
    src: "https://www.predictiveservices.nifc.gov/outlooks/month2_outlook.png",
  },
  {
    label: "NIFC Current day Significant Wildfire Potential",
    src: "https://fsapps.nwcg.gov/psp/npsg/data/conus-sevenday/d1_0.png",
  },
  {
    label: "NIFC Day Two significant Wildfire Potential",
    src: "https://fsapps.nwcg.gov/psp/npsg/data/conus-sevenday/d2_0.png",
  },
  {
    label: "NIFC Day Three Significant Wildfire Potential",
    src: "https://fsapps.nwcg.gov/psp/npsg/data/conus-sevenday/d3_0.png",
  },
];
const d = new Date();
d.setDate(d.getDate() - 1);
const utcyear = d.getUTCFullYear();
const utcMonth = String(d.getUTCMonth() + 1).padStart(2, "0");
const utcDate = String(d.getUTCDate()).padStart(2, "0");
const filename = String(utcyear).slice(2) + utcMonth + utcDate;
const spc = [
  {
    label: "Day 1 Fire Weather Outlook",
    src: "https://www.spc.noaa.gov/products/fire_wx/fwdy1_print.html",
  },
  {
    label: "Day 2 Fire Weather Outlook",
    src: "https://www.spc.noaa.gov/products/fire_wx/fwdy2_print.html",
  },
  {
    label: "Day 3-8 Fire Weather Outlook",
    src: `https://www.spc.noaa.gov/products/exper/fire_wx/${utcyear}/${filename}.html`,
  },
];

export default function Wildfire() {
  return (
    <Page>
      <img src="./background/wildfire.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center 50%" }}></img>
      <Container sx={{ py: 5 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Box sx={{ marginBottom: 2 }}>
          <Typography variant="h3">Wildfire</Typography>
          <Typography sx={{ textAlign: "justify" }}>
            The Commonwealth of Kentucky is 48% forests comprising over 12
            million acres. They remain among the nation's most diverse hardwood
            forests in the country, second only to Florida. In addition,
            Kentucky's parks are among its most visited destinations. As a
            recreation and economic resource, the state's forests are a treasure
            to be nurtured and protected. Nevertheless, wildfire is their
            primary threat. On average, nearly 1,500 files occur annually across
            the state with arson the greatest cause of fires. With local, high
            quality weather data, fire conditions can be more accurately
            predicted, and fires can be fought more safely and effectively.
          </Typography>
        </Box>
        {/* <Paper elevation={3}>
          <ReusableTabs items={wf}></ReusableTabs>
        </Paper> */}
        {/* <Divider sx={{ my: 5 }}></Divider> */}
        <Box>
          <Typography variant="h4">
            Southern Area Fire Environment Outlook
          </Typography>
          <iframe
            src="https://nifc.maps.arcgis.com/apps/MapJournal/index.html?appid=9e42f13b0fe94db3bfac51c9c3a19296"
            style={{
              width: "100%",
              height: 650,
              minHeight: 650,
            }}
          ></iframe>
        </Box>
        <Divider sx={{ my: 5 }}></Divider>
        <Paper elevation={3}>
          <ReusableTabs
            items={spc}
            iframe={true}
            panelHeight={1000}
          ></ReusableTabs>
        </Paper>
      </Container>
    </Page>
  );
}
